<div class="main-container" >
    <div class="header-title" *ngIf="isHome">
        <div class="left">
            <div class="back-icon">
                <img src="assets/navbar-component-images/fluent_ios-arrow-24-filled.svg" alt="" (click)="goBack()">
            </div>
            <div class="title">
                <h2>{{input_text.value}}</h2>
            </div>
        </div>
    </div>
    <div class="gap" *ngIf="!isHome"></div>
    <app-search-box *ngIf="!isHome"
    [search_input]="input_text" 
    [width]="'100%'"
    [top]="'-20px'"
    (onSearch)="onSearch($event)"
    (onAiSearch)="onAiSearch($event)"
    (onBackButtonClick)="goBack()"></app-search-box>

    <div class="search-result-container">
        <div class="option-container">
            <p>ผลการค้นหา {{ resultsFound }} รายการ</p>
            <div class="button-container">
                <button class="list-button" [ngClass]="{'active': showList}" (click)="onListButtonClick()">
                    <img [src]="list_icon_deactive" alt="list_icon">
                </button>
                <button class="box-button" [ngClass]="{'active': !showList}" (click)="onBoxButtonClick()">
                    <img [src]="box_icon_deactive" alt="box_icon">
                </button>
            </div>
            <p>เรียงตาม</p>
            <select [(ngModel)]="select" (change)="onSelectChange()">
                <option>เกี่ยวข้อง</option>
                <option>จำนวนการดู</option>
                <option>เวลาที่อัพโหลด</option>
            </select>
        </div>
        <div *ngIf="notFound" class="not-found-message custom-not-found">
            <p>Not Found</p>
        </div>
        <app-list-results *ngIf="showList && !notFound"
        [results]="results"
        [loading]="loadingNews || !ready"
        [descriptionLines]="2"
        [showMapButton]="true"
        [imageHeight]="'200px'"
        [imageRatio]="16 / 9"
        [nameDateConnect]="true"
        [skeleton]="true"
        [reachTheEnd]="reachTheEnd"
        (onRequestMoreSearchResults)="getMoreNews()"
        (onResultClick)="onResultClick($event)"
        (onMapButtonClick)="goToMap($event)"
        ></app-list-results>
        <app-box-results *ngIf="!showList"
        [results]="results"
        [loading]="loadingNews"
        [skeleton]="true"
        [reachTheEnd]="reachTheEnd"
        (onMapButtonClick)="goToMap($event)"
        (onResultClick)="onResultClick($event)"
        (onRequestMoreSearchResults)="getMoreNews()"
        ></app-box-results>
    </div>
</div>